/**
 * §7.2 Commercial Philosophy — "You're Licensing an Entire Business
 * Platform".  Nine pillar cards showing the full stack customers
 * get instead of building from scratch.
 */

import React from 'react'
import {
  Bot, LineChart, Building2, GraduationCap, UsersRound, PieChart,
  CreditCard, Cog, RefreshCw, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { PHILOSOPHY_PILLARS } from '../data'

const ICONS = {
  Bot, LineChart, Building2, GraduationCap, UsersRound, PieChart,
  CreditCard, Cog, RefreshCw, Sparkles,
}

export default function Philosophy() {
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Commercial Philosophy</Eyebrow>
          <SectionHeading
            align="center"
            title={<>You&apos;re licensing{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">an entire business platform.</span></>}
            subtitle="Kalki Ai Cloud is not a retail SaaS subscription. Every licence is an operating platform for a full trading business — not a single tool."
          />
        </div>

        <FeatureGrid items={PHILOSOPHY_PILLARS} icons={ICONS} cols={3} />

        <div className="rounded-2xl border border-brand-gold/25 bg-brand-gold/[0.05] px-5 md:px-6 py-4 backdrop-blur-xl flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-4">
          <Sparkles className="h-4 w-4 text-brand-gold shrink-0" />
          <p className="text-sm text-zinc-100 leading-relaxed">
            <span className="font-semibold text-white">Instead of building software from zero,</span>{' '}
            you inherit years of enterprise-grade engineering across every layer of the trading business.
          </p>
        </div>
      </Container>
    </section>
  )
}
